var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlternativenames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2H10M10 2H14M10 2V13M10 13H6M10 13H14",
    stroke: "#33363F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5H2.55556C1.69645 5 1 5.74619 1 6.66667V10H8",
    stroke: "#33363F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H15.4C16.2837 10 17 9.25383 17 8.33333V5H13",
    stroke: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternativenames);
export default __webpack_public_path__ + "static/media/Alternative names.0068b88b99f6f280f475a792bd9ce9db.svg";
export { ForwardRef as ReactComponent };